import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as Edit } from '@/assets/img/edit-icon-new-v2.svg';

import 'react-datepicker/dist/react-datepicker.css';
import { Heading } from '@/components/Elements/Heading';
import './Subscriptions.scss';
import { ActionMenu } from '@/components/Elements/ActionMenu';
import { TableData } from '@/components/Elements/Table/TableData';
import { UserContext } from '@/routes';
import { formatDate } from '@/utils/format';
import ReactPaginate from 'react-paginate';
import { useGetSubscriptions } from '../api/getSubscriptions';
import SubscriptionCard from '../components/SubscriptionCard';
import { Subscriber } from '../types';
import LinkSubscription from '../components/LinkSubscriptions';

export const Subscriptions = () => {
  const perPage = 10;
  const userContext = useContext(UserContext);
  const [selectedPage, setSelectedPage] = useState(1);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const useSubscriptionsMutation = useGetSubscriptions();
  const [subscriptions, setSubscriptions] = useState<Subscriber[]>();
  const [selectedSubscriber, setSelectedSubscriber] = useState<Subscriber>();

  const [searchQuery, setSearchQuery] = useState<string>();
  useEffect(() => {
    getSubscriptions();
  }, [selectedPage]);
  useEffect(() => {
    if (selectedPage != 1) {
      setSelectedPage(1);
    }
  }, [searchQuery]);

  const getSubscriptions = async () => {
    const res = await useSubscriptionsMutation.mutateAsync({
      page: selectedPage,
      perPage: perPage,
      search: searchQuery,
    });
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    setSubscriptions(res.subscribersList);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const onTableStateChange = (pageIndex: number, reset: boolean) => {
    setSelectedPage(pageIndex);
  };
  const handlePageClick = (event: any) => {
    setSelectedPage(event.selected + 1);
  };
  const linkSubscription = (subscriber: Subscriber) => {
    setSelectedSubscriber(subscriber);
  };
  const startIndex = selectedPage == 1 ? 1 : (selectedPage - 1) * perPage + 1;
  let endIndex =
    selectedPage == 1
      ? 1 * perPage
      : selectedPage == totalRecords
      ? totalRecords
      : selectedPage * perPage;

  if (endIndex > totalRecords) {
    endIndex = totalRecords;
  }
  const paginationText = `Showing ${startIndex} to ${endIndex} of ${totalRecords} entries`;
  return (
    <>
      <section className="subscription-list container-bg">
        <div className="content">
          <div className="card-top-header">
            <Heading title="Subscriptions" description="Manage user Subscriptions" />
          </div>
        </div>
        <div className="subscription-list-header">
          <div className="left-action"></div>
          {/* <div className="right-action">
            <span className="search-content">
              <SearchIcon />
              <input type="text" id="simple-search" placeholder="Search" onChange={handleChange} />
            </span>
          </div> */}
        </div>
        <div className="subscription-list petsked-table">
          {userContext?.isLandscape ? (
            <TableData<Subscriber>
              data={subscriptions}
              columns={[
                {
                  title: 'Subscriber Name',
                  field: 'name',
                  Cell({ entry: { name } }) {
                    return <span className="default">{name}</span>;
                  },
                },
                {
                  title: 'Phone Number',
                  field: 'phone',
                  Cell({ entry: { phone } }) {
                    return <span className="default">{phone}</span>;
                  },
                },

                {
                  title: 'Email',
                  field: 'email',
                  Cell({ entry: { email } }) {
                    return <span className="default remove-capitalize">{email}</span>;
                  },
                },
                {
                  title: 'Created At',
                  field: 'createdAt',
                  Cell({ entry: { createdAt } }) {
                    return (
                      <span className="default">
                        {createdAt && formatDate(createdAt, 'DD MMM YYYY')}
                      </span>
                    );
                  },
                },
                {
                  title: 'Business',
                  field: 'subscription',
                  Cell({ entry: { subscription } }) {
                    return (
                      <span className="default ">
                        {subscription && subscription.business ? subscription.business.name : ''}
                      </span>
                    );
                  },
                },
                {
                  title: 'Status',
                  field: 'subscription',
                  Cell({ entry: { subscription } }) {
                    return (
                      <span className="default">
                        {subscription ? subscription.status : 'Not Linked'}
                      </span>
                    );
                  },
                },
                {
                  title: 'Action',
                  field: 'id',
                  Cell({ entry: subscriber }) {
                    return (
                      <ActionMenu
                        options={[
                          {
                            label: 'Map to Business',
                            icon: Edit,
                            onClickHandler: () => linkSubscription(subscriber),
                            itemClassName: '',
                          },
                        ]}
                      />
                    );
                  },
                },
              ]}
              tableInitialState={{
                tableTotalRecords: totalPages,
                tablePageIndex: tableCurrentIndex,
              }}
              onTableStateChange={onTableStateChange}
              isDataLoading={useSubscriptionsMutation.isLoading}
              showPagination={true}
            />
          ) : (
            <>
              {' '}
              {subscriptions &&
                subscriptions.map((subscriber, index) => (
                  <SubscriptionCard
                    key={`business-card-${index}`}
                    data={subscriber}
                    actionMenuOptions={[
                      {
                        label: 'Map to Business',
                        icon: Edit,
                        onClickHandler: () => linkSubscription(subscriber),
                        itemClassName: '',
                      },
                    ]}
                  />
                ))}
              {totalPages > 1 && (
                <div className="paginate">
                  <p className="description">{paginationText}</p>
                  <div className="pagination-stores">
                    <ReactPaginate
                      nextLabel=""
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={totalPages}
                      previousLabel=""
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item previous-button"
                      previousLinkClassName="page-link"
                      nextClassName="page-item next-button"
                      nextLinkClassName="page-link"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {selectedSubscriber && (
          <LinkSubscription
            open={selectedSubscriber ? true : false}
            onClose={() => {
              setSelectedSubscriber(undefined), getSubscriptions();
            }}
            subscription={selectedSubscriber}
          />
        )}
      </section>
    </>
  );
};
